"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = _interopRequireDefault(require("immutable"));

var _ThinListing = _interopRequireDefault(require("ecosystem-marketplace-core/records/ThinListing"));

var _StorefrontFilters = _interopRequireDefault(require("./StorefrontFilters"));

var defaults = {
  filters: new _StorefrontFilters.default(),
  items: _immutable.default.OrderedSet(),
  total: 0
};

var SearchResult = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(SearchResult, _Immutable$Record);

  function SearchResult() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, SearchResult);

    if (json.filters) {
      json.filters = new _StorefrontFilters.default(json.filters);
    }

    if (json.items) {
      json.items = _immutable.default.OrderedSet(json.items.map(function (result) {
        return new _ThinListing.default(result);
      }));
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SearchResult).call(this, json));
  }

  return SearchResult;
}(_immutable.default.Record(defaults));

var _default = SearchResult;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/records/SearchResult.js
// module id = 177
// module chunks = 209 210 211 212 213